import APIService from "./APIService";

export default class NotificationsService extends APIService {  
  path = "notifications";
}